export enum LoanApplicationOrigin {
  ONLINE_FLOW = 'ONLINE_FLOW',
  ONLINE_SDK = 'ONLINE_SDK',
  CHECKOUT_PLATFORM = 'CHECKOUT_PLATFORM',
  INTEGRATED_PREQUAL_LINK = 'INTEGRATED_PREQUAL_LINK',
  MERCHANT_LINK = 'MERCHANT_LINK',
  ALLIANCE_LINK = 'ALLIANCE_LINK',
  DASHBOARD_PS1 = 'DASHBOARD_PS1',
  ORGANIC_PREQUAL_LINK = 'ORGANIC_PREQUAL_LINK',
  MERCHANT_PREQUAL_LINK = 'MERCHANT_PREQUAL_LINK',
  ALLIANCE_PREQUAL_LINK = 'ALLIANCE_PREQUAL_LINK',
  CALL_CENTER_PREQUAL_LINK = 'CALL_CENTER_PREQUAL_LINK',
}
